import {ApiService} from "./ApiService";
import UrlEndpoints from "./UrlEndpoints";

export default class AccountManagementService {
    static async getAccountList() {
        return await ApiService.get(UrlEndpoints.GET_ACCOUNT);
    }

    static async updateSubscription(premisesId, request) {
        await ApiService.post(UrlEndpoints.UPDATE_SERVICES+"?premisesId="+premisesId, request);
    }
}